var _defs, _path, _path2, _polygon, _polygon2, _polygon3, _path3, _polygon4, _path4, _path5, _path6, _path7, _g, _path8, _path9, _polygon5, _path0, _polygon6, _polygon7, _path1, _polygon8, _polygon9, _path10, _polygon0, _g2, _path11, _path12, _path13, _g3, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatingInstallationRepairAndBreakdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f07662;}.cls-2{fill:#f39889;}.cls-3{fill:#e5e5e5;}.cls-4{fill:#e4e7ef;}.cls-5{fill:#999;}.cls-6{fill:#90a6be;}.cls-7{fill:#b3b3b3;}.cls-8{fill:#adb5c1;}.cls-9{fill:#ccc;}.cls-10{fill:gray;}.cls-11{fill:#4a535a;}.cls-12{mask:url(#mask-1);}.cls-12,.cls-13{fill:none;}.cls-13{mask:url(#mask);}.cls-14{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 23.75,
    y: 82.37,
    width: 33.92,
    height: 32.08,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    className: "cls-14",
    points: "57.67 114.45 23.75 114.45 23.75 82.37 57.67 82.37 57.67 114.45"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 5.75,
    y: 79.37,
    width: 33.92,
    height: 32.08,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-16-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-15-2",
    className: "cls-14",
    points: "39.67 111.45 5.75 111.45 5.75 79.37 39.67 79.37 39.67 111.45"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1.02,48.66l2.42-1.36c.16-.14.33-.24.53-.31,1.23-.44,2.76.68,3.41,2.5.65,1.82.17,3.65-1.06,4.09-1.23.44-2.76-.68-3.41-2.5l-1.89-2.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m37.28,70.02v-6.55l5.12,2.6c-.07-.26-.15-.53-.24-.79-1.3-3.66-4.37-5.91-6.84-5.03-2.48.88-3.43,4.56-2.12,8.22,1.3,3.66,4.36,5.91,6.84,5.03.66-.24,1.21-.67,1.64-1.25l-4.39-2.23Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2.54 48.51 2.54 55.06 34.8 71.42 34.8 64.88 2.54 48.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "34.8 71.42 37.64 69.98 37.64 63.44 34.8 64.88 34.8 71.42"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "5.38 47.07 37.64 63.44 34.8 64.88 2.54 48.51 5.38 47.07"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m34.66,71.33v-6.55l5.12,2.6c-.07-.26-.15-.53-.24-.79-1.3-3.66-4.37-5.91-6.84-5.03-2.48.88-3.43,4.56-2.12,8.22,1.3,3.66,4.36,5.91,6.84,5.03.66-.24,1.21-.67,1.64-1.25l-4.39-2.23Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "39.05 73.55 41.67 72.24 37.64 69.98 34.8 71.42 39.05 73.55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m32.69,61.56c2.48-.88,5.54,1.37,6.84,5.03.09.26.17.53.24.79l2.62-1.31c-.07-.26-.15-.53-.24-.79-1.3-3.66-4.37-5.91-6.84-5.03l-2.62,1.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m41.67,72.24s-1.22,2-3.95,2.43c0,0,.54-.22,1.33-1.12l2.62-1.31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-7",
    d: "m.29,52.6c-.65-1.82-.18-3.66,1.06-4.09,1.23-.44,2.76.68,3.41,2.5.65,1.82.17,3.65-1.06,4.09-1.23.44-2.76-.68-3.41-2.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-10",
    d: "m1.6,52.13c-.27-.76-.07-1.52.44-1.7.51-.18,1.14.28,1.41,1.04.27.76.07,1.52-.44,1.7-.51.18-1.14-.28-1.41-1.04"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-3",
    points: "86 75.93 86 34.57 96.46 29.24 96.46 70.67 86 75.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    className: "cls-9",
    points: "27.8 5.33 86 34.57 86 75.93 27.8 46.83 27.8 5.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    className: "cls-4",
    points: "96.46 29.24 38.2 0 27.8 5.33 86 34.57 96.46 29.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-8",
    d: "m71.38,32.15l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm3.5,1.77l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-24.21-12.02l1.42.76v32.98l-1.42-.62V25.29Zm3.46,1.7l1.42.76v32.98l-1.42-.62V26.98Zm3.5,1.77l1.42.76v32.98l-1.42-.62V28.75Zm3.46,1.7l1.42.76v32.98l-1.42-.62V30.45Zm-24.21-12.05l1.42.76v32.98l-1.42-.62V18.39Zm-3.22-1.7l1.42.76v32.98l-1.42-.62V16.7Zm-3.4-1.7l1.42.76v32.98l-1.42-.62V15Zm-3.43-1.66l1.42.76v32.98l-1.42-.62V13.34Zm-3.33-1.66l1.42.76v32.98l-1.42-.62V11.67Zm16.84,8.42l1.42.76v32.98l-1.42-.62V20.09Zm3.5,1.77l1.42.76v32.98l-1.42-.62V21.86Zm3.46,1.7l1.42.76v32.98l-1.42-.62V23.56Zm31.8,12.89l-.09-.04L27.8,7.46v-.45l58.23,28.99,10.43-5.09v.45l-10.43,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-11",
    d: "m92.65,37.29c-.69-.25-1.56.44-1.95,1.54-.39,1.09-.15,2.18.54,2.43l1.41.6,1.9-3.58-1.9-.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-2",
    d: "m98.52,38.72l-3.06-1.34c-1.17-.42-2.62.65-3.24,2.38-.62,1.73-.17,3.47,1,3.89l3.06,1.34c1.17.42,2.62-.65,3.24-2.38.62-1.73.17-3.47-1-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-1",
    d: "m99.52,42.61c-.62,1.73-2.06,2.8-3.24,2.38-1.17-.42-1.62-2.16-1-3.89.62-1.73,2.07-2.8,3.24-2.38,1.17.42,1.62,2.16,1,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-11",
    d: "m92.53,28.2l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.7-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.42l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.63-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.25l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.6-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm49.1,67.98v2.6s.16,1.25,1.04.83l5.77-2.86s.67-.36.73-2.03v-2.18s-.05-1.2-1.2-.62l-5.35,2.6s-.99.57-.99,1.66"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m92.59,80.01s1.29-.56,1.85.21-.19,1.54-.19,1.54l-7.83,5.2-3.63,2.32s-1.82,1.31-3.53.29l-7.1-3.96s-1.03-.4-.51-1.53c.52-1.14,1.46-.38,1.46-.38l6.76,3.77s.81.47,1.57-.04c.76-.51,5.14-3.43,5.14-3.43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.59,92.01s-4.38,2.92-5.14,3.43c-.76.51-1.57.04-1.57.04l-6.76-3.77s-.94-.77-1.46.38c-.52,1.14.51,1.53.51,1.53l7.1,3.96c1.72,1.02,3.53-.29,3.53-.29l3.63-2.32,7.83-5.2s.74-.77.19-1.54-1.85-.21-1.85-.21l-6,4Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "63.65 77.99 60.62 79.54 56.48 79.35 55.52 76.95 55.52 75.92 57 76.11 57.51 77.8 60.62 77.8 62.17 76.76 63.65 76.95 63.65 77.99"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m62.17,74.69l-3.62-.33-3.03,1.55.96,2.4,4.14.19,3.03-1.55-1.48-2.26Zm-1.93,3.06l-2.64-.12-.61-1.53,1.93-.99,2.31.21.94,1.44-1.93.99Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "58.93 76.15 61.23 76.36 61.66 77.02 62.17 76.76 61.23 75.33 58.93 75.12 57 76.11 57.34 76.96 58.93 76.15"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "67 86.36 63.97 87.91 59.83 87.73 58.87 85.33 58.87 84.29 60.35 84.48 60.86 86.17 63.97 86.17 65.52 85.14 67 85.33 67 86.36"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m65.52,83.07l-3.62-.33-3.03,1.55.96,2.4,4.14.19,3.03-1.55-1.48-2.26Zm-1.93,3.06l-2.64-.12-.61-1.53,1.93-.99,2.31.21.94,1.44-1.93.99Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "62.27 84.53 64.58 84.74 65.01 85.4 65.52 85.14 64.58 83.7 62.27 83.49 60.35 84.48 60.69 85.34 62.27 84.53"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "55.28 86.36 52.25 87.91 48.1 87.73 47.14 85.33 47.14 84.29 48.62 84.48 49.14 86.17 52.25 86.17 53.8 85.14 55.28 85.33 55.28 86.36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m53.8,83.07l-3.62-.33-3.03,1.55.96,2.4,4.14.19,3.03-1.55-1.48-2.26Zm-1.93,3.06l-2.64-.12-.61-1.53,1.93-.99,2.31.21.94,1.44-1.93.99Z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.55 84.53 52.86 84.74 53.29 85.4 53.8 85.14 52.86 83.7 50.55 83.49 48.62 84.48 48.97 85.34 50.55 84.53"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-19-Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "cls-7",
    d: "m33,89c0-.67,1-1,3.56.31h0s6.53,3.76,6.53,3.76l-1.53,1.78-6.2-3.5s-2.36-1.36-2.36-2.36Z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    className: "cls-9",
    d: "m44.37,94.48c-.62,1.73-2.06,2.8-3.24,2.38-1.17-.42-1.62-2.16-1-3.89.62-1.73,2.07-2.8,3.24-2.38,1.17.42,1.62,2.16,1,3.89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m44.22,92.99c.41,1.34-1.57,1.95-2.6,1.84-2.3-.3.01-.79.94-.97.64-.18,1.32-.19,1.66-.87h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42,96c.07-.84.57-1.34.67-2.14.15-.77-.03-1.44.13-2.24.95.9.5,3.97-.8,4.38h0Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-19-Clipped-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19-2",
    className: "cls-7",
    d: "m15,86c0-.67,1-1,3.56.31h0s6.53,3.76,6.53,3.76l-1.53,1.78-6.2-3.5s-2.36-1.36-2.36-2.36Z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "cls-9",
    d: "m26.37,91.48c-.62,1.73-2.06,2.8-3.24,2.38-1.17-.42-1.62-2.16-1-3.89.62-1.73,2.07-2.8,3.24-2.38,1.17.42,1.62,2.16,1,3.89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.22,89.99c.41,1.34-1.57,1.95-2.6,1.84-2.3-.3.01-.79.94-.97.64-.18,1.32-.19,1.66-.87h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24,93c.07-.84.57-1.34.67-2.14.15-.77-.03-1.44.13-2.24.95.9.5,3.97-.8,4.38h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingInstallationRepairAndBreakdown);
export default __webpack_public_path__ + "static/media/heating-installation-repair-and-breakdown.20910764adbe8f6ebfb94d02e7e40611.svg";
export { ForwardRef as ReactComponent };